const earthRadiusMeters = 6_371_000;

export function formatThumbnailDistance(distanceMeters: number): string | undefined {
    if (!Number.isFinite(distanceMeters) || distanceMeters < 0) {
        return undefined;
    }

    return distanceMeters < 1_000
        ? `${Math.round(distanceMeters)} m`
        : `${Math.round(distanceMeters / 1_000)} km`;
}

export function isValidCoordinates(latitude: number, longitude: number): boolean {
    return Number.isFinite(latitude) && Number.isFinite(longitude) &&
        latitude >= -90 && latitude <= 90 && longitude >= -180 && longitude <= 180;
}

export function distanceInMeters(
    fromLatitude: number,
    fromLongitude: number,
    toLatitude: number,
    toLongitude: number
): number {
    const latitudeDelta = toRadians(toLatitude - fromLatitude);
    const longitudeDelta = toRadians(toLongitude - fromLongitude);
    const fromLatitudeRadians = toRadians(fromLatitude);
    const toLatitudeRadians = toRadians(toLatitude);
    const halfChordLength = Math.sin(latitudeDelta / 2) ** 2 +
        Math.cos(fromLatitudeRadians) * Math.cos(toLatitudeRadians) * Math.sin(longitudeDelta / 2) ** 2;

    return earthRadiusMeters * 2 * Math.atan2(Math.sqrt(halfChordLength), Math.sqrt(1 - halfChordLength));
}

function toRadians(value: number): number {
    return value * Math.PI / 180;
}
